import { Component } from '@angular/core';
import { AlertController, Events, IonicPage, NavController, NavParams, PopoverController, Tabs } from 'ionic-angular';
import { PaymentChangeMethodPopoverPage } from "../payment-change-method-popover/payment-change-method-popover";
import { HttpClient } from "@angular/common/http";
import { StripeServiceProvider } from "../../providers/stripe-service/stripe-service";
import moment from "moment";
import { CustomerNameModalPage } from "../customer-name-modal/customer-name-modal";
import { TimezoneProvider } from "../../providers/timezone/timezone";
import { ApiErrorHandlerProvider } from "../../providers/api-error-handler/api-error-handler";
import { PaymentNewCardPage } from "../payment-new-card/payment-new-card";
import { BookingServiceProvider } from "../../providers/booking-service/booking-service";
import { PaymentErrorPage } from "../payment-error/payment-error";
import { ServicesPage } from "../services/services";
import { BookingsPage } from '../bookings/bookings';
import { TabsPage } from '../tabs/tabs';


@IonicPage()
@Component({
  selector: 'page-payment',
  templateUrl: 'payment.html',
})
export class PaymentPage {

  public loadingPaymentMethods: boolean;
  public loading: boolean;
  public customer: any;
  public paymentMethods: any;
  public defaultPaymentMethod: object;
  public intent: any;
  public card: any;
  public shop: any;
  public barber: any;
  public booking: any;
  public bookingType: number;
  public services: any;
  public advancedBooking: any;
  public guestUser: any = null;
  public byStaff: boolean;
  public fromLobby: boolean;
  public fromStaffPanel: boolean;
  public currencySymbol: string;
  public totalAfterRedemptionApplied: any;
  public totalRedemptionApplied: any;
  public totalCost: any;
  public errors: {};
public isFromReschedule : boolean = false;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public popoverCtrl: PopoverController,
    public events: Events,
    public http: HttpClient,
    public stripeService: StripeServiceProvider,
    public tz: TimezoneProvider,
    private apiErrorHandler: ApiErrorHandlerProvider,
    private alertCtrl: AlertController,
    public bookingService: BookingServiceProvider
  ) {
    this.paymentMethods = [];
    this.shop = navParams.get('shop');
    this.barber = navParams.get('barber');
    this.booking = navParams.get('booking');
    this.services = navParams.get('services');
    this.advancedBooking = navParams.get('advancedBooking');
    this.bookingType = navParams.get('bookingType') ? navParams.get('bookingType') : 1; // 1 = Standard
    this.byStaff = navParams.get('byStaff') ? true : false;
    this.fromLobby = navParams.get('fromLobby') ? true : false;
    this.fromStaffPanel = navParams.get('fromStaffPanel') ? true : false;
    this.guestUser = navParams.get('guestUser');
    this.totalAfterRedemptionApplied = navParams.get('totalAfterRedemptionApplied');
    this.totalCost = this.totalAfterRedemptionApplied ? this.totalAfterRedemptionApplied : this.services.totalCost;
    this.totalRedemptionApplied = navParams.get('totalRedemptionApplied');
    this.isFromReschedule = navParams.get('isFromReschedule') ? true : false;
    console.log("is from ", this.isFromReschedule);


    this.bookingService.setServiceTotals(this.services, this.shop);

    tz.timezone(this.shop).then((currencySymbol: string) => {
      this.currencySymbol = currencySymbol;
    });

    events.subscribe('stripe:paymentMethodSaved', (paymentMethod) => {
      this.paymentMethods.data.push(paymentMethod);
      this.defaultPaymentMethod = paymentMethod;
      this.customer.invoice_settings.default_payment_method = paymentMethod.id;
    });
  }

  ionViewDidLoad() {
    this.subscribeToBookingServiceProviderEvents();
    this.loadingPaymentMethods = true;
    this.stripeService.getCustomer().then((customer: any) => {
      this.customer = customer;
      this.stripeService.getPaymentMethods().then((methods: any) => {
        this.paymentMethods = methods;
        this.setDefaultSource();
        this.loadingPaymentMethods = false;
      });
    },
      err => {
        console.log(err);
        this.loadingPaymentMethods = false;
      });
  }

  ngOnDestroy() {
    this.bookingService.unsubscribeFromEvents();
  }

  subscribeToBookingServiceProviderEvents() {

    this.bookingService.unsubscribeFromEvents();

    this.events.subscribe('validateStandardBookingFitsBetweenAdvancedBookings:chooseAnotherBarber', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 3));
    });

    this.events.subscribe('validateStandardBookingFitsBetweenAdvancedBookings:changeServiceTime', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 2));
    });

    this.events.subscribe('validateStandardBookingFitsBetweenAdvancedBookings:forceAddToQueue', booking => {
      this.joinQueue(booking);
    });

    this.events.subscribe('validateStandardBookingFitsBetweenAdvancedBookings:joinAvailableSlot', booking => {
      this.joinQueue(booking);
    });

    this.events.subscribe('validateStandardBookingEndsBeforeTeamOrMemberEndTime:forceAddToQueue', booking => {
      this.joinQueue(booking);
    });

    this.events.subscribe('validateReplacedBookingFitsAvailableSlot:cancel', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 4));
    });

    this.events.subscribe('validateReplacedBookingFitsAvailableSlot:chooseAnotherBarber', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 4));
    });


    this.events.subscribe('booking:forceAddToQueue', booking => {
      this.joinQueue(booking);
    });

    this.events.subscribe('booking:changeServiceTime', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 2));
    });

    this.events.subscribe('booking:backToStart', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 3));
    });

    this.events.subscribe('booking:chooseAnotherBarber', booking => {
      let currentIndex = this.navCtrl.getActive().index;
      this.navCtrl.popTo(this.navCtrl.getByIndex(currentIndex - 3));
    });

  }

  addPaymentMethod() {
    if (this.loading) return;
    this.navCtrl.push(PaymentNewCardPage, { referrer: 'paymentPage' })
  }

  setDefaultSource() {
    return new Promise((resolve) => {
      for (let paymentMethod of this.paymentMethods.data) {
        if (paymentMethod.id === this.customer.invoice_settings.default_payment_method) {
          this.defaultPaymentMethod = paymentMethod;
          resolve(true);
        }
      }
    });
  }

  changePaymentMethod() {

    if (this.loading) return;

    let modal = this.popoverCtrl.create(PaymentChangeMethodPopoverPage,
      {
        paymentMethods: this.paymentMethods,
        defaultPaymentMethod: this.defaultPaymentMethod,
      },
      {
        cssClass: 'change-payment-method-popover',
        enableBackdropDismiss: false
      });

    modal.present();

    modal.onDidDismiss((customer) => {
      if (customer) {
        this.customer = customer;
        this.setDefaultSource();
      }
    })
  }

  paymentIntent() {
    return this.stripeService.createPaymentIntent(this.totalCost, this.customer, this.booking.team);
  }

  makeBooking(booking: any = null) {
    return this.bookingService.makeBooking((booking ? booking : this.booking), this.navCtrl, this.byStaff, this.fromLobby, this.totalRedemptionApplied, this.fromStaffPanel, 'barber');
  }

  joinQueue(booking: any = null) {

    if (this.loading) return;
    this.loading = true;

    // We pass the booking as it might have been updated in one of the validation events, if it's present it will override this.booking
    this.makeBooking(booking).then(booking => {
      // The booking was made successfully so we'll now attempt to capture the payment for the booking
      return new Promise(resolve => {
        this.paymentIntent().then(paymentIntent => {
          // The payment was captured successfully
          return resolve([paymentIntent, booking]);
        }).catch(error => {
          // We weren't able to capture the payment
          // this.navCtrl.push(PaymentErrorPage, {
          //   paymentIntentId: error.payment_intent.id,
          //   shopType: 'barber'
          // })
          this.OnCancelPayments();
        });
      });
    }).then(([payment, booking]: any) => {
      // We'll now trigger app events from the booking provider and update the booking with the payment details
      return this.bookingService.bookingSuccessful(booking, payment, 'barber');
    }).then((booking: any) => {
      if (!this.byStaff) {
        this.events.publish('booking:badge+', booking);
      }

      if (booking.staff_member.user_id === parseInt(localStorage.getItem('tuid'))) {
        this.events.publish('myChair:badge', booking);
      }
    }).then(_ => {
      this.bookingService.gotoMyBookings(this.navCtrl);
    }).catch(error => {
      this.loading = false;
    });

  }

  OnCancelPayments() {
    const alert = this.alertCtrl.create({
      subTitle: 'Your Card has been declined due to insufficient fund or expired card we have added you to the queue please pay at the shop.',
      enableBackdropDismiss: false,
      buttons: [
        {
          text: 'OKAY',
          handler: () => {
            this.bookingService.gotoMyBookings(this.navCtrl);
          }
        }]
    });
    alert.present();
  }

  payInShop() {

    if (this.loading) return;

    let alert = this.alertCtrl.create({
      title: "Pay at barbershop",
      subTitle: "Are you sure you want to pay at the barbershop?",
      enableBackdropDismiss: false,
      buttons: [
        {
          text: 'Yes, Pay at barbershop',
          handler: () => {

            this.loading = true;
            this.makeBooking().then(booking => {
              return this.bookingService.bookingSuccessful(booking, null, 'barber');
            }).then((booking: any) => {
              if (!this.byStaff) {
                this.events.publish('booking:badge+', booking);
              }

              if (booking.staff_member.user_id === parseInt(localStorage.getItem('tuid'))) {
                this.events.publish('myChair:badge', booking);
              }
            }).then(() => {
              return this.bookingService.gotoMyBookings(this.navCtrl);
            }).then(() => {
              if(this.isFromReschedule){
                this.events.publish('booking:cancelled', "");
                this.navCtrl.popAll();
              }
              this.loading = false;
            }).catch(error => {
              this.loading = false;
            });

          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
          }
        },
      ]
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/payment/payment.ts